import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo } from 'react';
import { useIsRowLayoutMode } from '../../hooks/useIsRowLayoutMode';
import { MttStagingMainPanel } from './panels/mttStagingMainPanel';
import { MttStagingPanelContainer } from './panels/mttStagingPanelContainer';
export const MttStagingSceneMainDisplay = () => {
    const isRowLayoutMode = useIsRowLayoutMode();
    const containerCss = useMemo(() => css `
      display: flex;
      justify-content: space-between;
      flex-direction: ${isRowLayoutMode ? 'row' : 'column-reverse'};
      /*
        TODO: See if this hacky height pixel amount can be removed.
        Note that changing this may impact the ability to scroll to all content at the bottom of a panel.
      */
      height: calc(100% - 60px);
      width: 100%;
    `, [isRowLayoutMode]);
    return (_jsxs("div", { css: containerCss, children: [_jsx(MttStagingMainPanel, {}), _jsx(MttStagingPanelContainer, {})] }));
};
